export enum EmailStatus {
  Pending = 'PENDING',
  Sent = 'SENT',
  Error = 'ERROR',
}

export const EmailStatusDisplayName = {
  [EmailStatus.Pending]: "Pending",
  [EmailStatus.Sent]: "Sent",
  [EmailStatus.Error]: "Error",
};
